export const AsyncTaskType = Object.freeze({
    StopWorkplanTask: 103,
    PauseWorkplanTask: 104,
    EditRolloutTask: 105,
    EditPauseTask: 106,
    RolloutTask: 107,
    ImportWorkplanShiftLineExcel: 108,
    ReloadCoverage: 109,
});